import React, { use, useEffect, useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
//UI
import { DangerButton, InfoButton, SuccessButton } from "../../../../ui/buttons/Button";
import { Input, Radio, SearchInput, Textarea } from "../../../../ui/inputs/Input";
import moment from "moment";
import { Mensaje } from "../../../mensajes2";
import CatalogoUbicacionBien from "../../../../catalogos/catalogoUbicacionBien";
import { Dimmer } from "../../../spinner";
import axios from "axios";
const op = require("../../../../modulos/datos");

export default function InventarioBienesMuebles({ show, setShow, setTabla }) {
  const idefiscal = JSON.parse(localStorage.getItem("idefiscal"));
  const idorganizacion = JSON.parse(localStorage.getItem("idorganizacion"));
  const token = localStorage.getItem("jwtToken");

  const txtId = useRef();
  const txtDescripcion = useRef();
  const txtDesdeFecha = useRef();

  const [mostrarCatalogo, setMostrarCatalogo] = useState(false);
  const [activate, setActivate] = useState(false);
  const [valdepen, setValdepen] = useState(0);
  const [desdeFecha, setDesdeFecha] = useState("");
  const [estado, setEstado] = useState("");
  const [municipio, setMunicipio] = useState("");
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });

  const seleccionarDependencia = async (idubi) => {
    const campos = "*";
    const nomtab = "ubicacionbien";
    const nomid = "idubicacionbien";
    const endpoint = `${op.conexion}/api/consulta/modeli?&campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${idubi}`;

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(async function (response) {
        if (response.status === 200) {
          if (response.data !== "") {
            const data = response.data;
            console.log(data);
            txtId.current.value = data.idubicacionbien;
            txtDescripcion.current.value = data.descripcion;
            await seleccionarEstadoMuni(idorganizacion);
            setMostrarCatalogo(false);
          } else {
            setActivate(false);
            txtId.current.value = "";
            txtDescripcion.current.value = "";
            txtId.current.focus();
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "no existe una Dependencia con este código.",
              icono: "informacion",
            });
          }
        }
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const seleccionarEstadoMuni = async (id) => {
    const endpoint = `${op.conexion}/api/bienes/transferenciainmueble/muniestado?&idorg=${id}`;

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(async function (response) {
        if (response.status === 200) {
          if (response.data !== "") {
            const data = response.data;
            setEstado(data.estado);
            setMunicipio(data.municipio);
          } else {
            setActivate(false);
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "Error al Cargar el Estado/Municipio",
              icono: "informacion",
            });
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      })
      .finally(() => setActivate(false));
  };

  const salir = () => {
    setShow(false);
    setTabla(0);
  };

  const onChangeFecha = (e) => {
    if (e.target.name === 'desde') {
      setDesdeFecha(e.target.value);
      let val2 = e.target.value !== "" ? 1 : 0;
      setValdepen(val2);
    }
  }

  const onChangeValidar = async () => {
    let sigue = true;

    if (txtDesdeFecha.current.value === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificacion",
        texto: `debe ingresar la fecha desde.`,
        icono: "informacion",
      });
      sigue = false;
      txtDesdeFecha.current.focus();
    } else if (txtId.current.value === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificacion",
        texto: `debe ingresar la dependencia.`,
        icono: "informacion",
      });
      sigue = false;
      txtId.current.focus();
    }

    if (sigue) {
      imprimirGeneral();
    }
  };

  const blanquear = () => {
    txtDescripcion.current.value = "";
    txtId.current.value = "";
    txtDesdeFecha.current.value = "";
    setEstado("");
    setMunicipio("");
    setMostrarCatalogo(false);
    setValdepen(0);
    setDesdeFecha("");
    setMensaje({
      mostrar: false,
      titulo: "",
      texto: "",
      icono: "",
    });
  };

  const imprimirGeneral = () => {
    try {
      const storedData = localStorage.getItem("post");
      if (!storedData) {
        console.error("No hay datos en localStorage");
        return;
      }
      const data = JSON.parse(storedData);
      const reporte = "Bienes_Inventario";
      let val2 = moment(desdeFecha).format("YYYY-MM-DD");
      let sql = "FechaIncorporacion <=" + "'" + val2 + "'";
      let sql3 = txtId.current.value;
      let uni = txtDescripcion.current.value.trim();
      let sql2 = "AL " + val2;

      let nombreorg = data.nombreorg.trim();
      let rif = data.riforg.trim();
      let spiritu = data.espiritu.trim();

      window.open(
        op.reportes +
        "/bienes?" +
        "reporte=" +
        reporte +
        "&ubicacion=" +
        sql3 +
        "&CONDICION=" +
        sql +
        "CONDICION1" +
        "'" + val2 + "'" +
        "&ESTADO=" +
        estado +
        "&MUNICIPIO=" +
        municipio +
        "&ORGANISMO=" +
        nombreorg +
        "&TITFEC=" +
        sql2 +
        "&UNIDAD=" +
        uni +
        "&TIPOREPORT=" +
        tiprep +
        "&RIF=" +
        rif,
        "&VIENE=" +
        spiritu,
        "Planilla",
        "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700",
      );
    } catch (error) {
      console.error("Error en imprimirGeneral:", error);
    }
  };

  return (
    <Modal size="lg" show={show} centered backdrop="static" keyboard={false}>
      <Modal.Header className="col-12 m-0 px-4 py-2 d-flex justify-content-between azulGradiant text-light rounded-top azulGradiant">
        <h3 className="fw-bold m-0">Listado de Desincorporaciones de Bienes Inmuebles</h3>
        <a type="button" className="fw-bold text-light fs-6" onClick={salir}>
          Salir <i className="fa fa-times ms-2"></i>
        </a>
      </Modal.Header>
      <Modal.Body>
        <fieldset className="col-12 m-0 mb-2 p-2 d-flex gap-2 border-azul rounded">
          <legend className="float-none w-auto m-0">Buscar por:</legend>
          <div className="col-auto m-0 p-0">
            <Input label='Al día:' type='date' ref={txtDesdeFecha} name='desde' value={desdeFecha} onChange={onChangeFecha} />
          </div>
        </fieldset>
        <fieldset className="col-12 m-0 p-2 d-flex gap-2 border-azul rounded">
          <legend className="float-none w-auto m-0">Dependencias</legend>
          <div className="col-3 m-0 p-0">
            <SearchInput
              ref={txtId}
              disabled
              label="CÓDIGO:"
              name="id"
              onClickButton={() => setMostrarCatalogo(true)}
              disabledButton={valdepen === 0 ? true : false}
            />
          </div>
          <Input label='Descripción:' disabled ref={txtDescripcion} />
        </fieldset>
      </Modal.Body>
      <Modal.Footer>
        <div className="col-12 d-flex m-auto justify-content-end">
          <div className="m-1 p-0">
            <InfoButton
              icon="fas fa-print"
              onClick={() => onChangeValidar()}
            >
              Imprimir
            </InfoButton>
          </div>
          <div className="m-1 p-0">
            <DangerButton onClick={() => salir()}>
              Cancelar
            </DangerButton>
          </div>
        </div>
      </Modal.Footer>
      <Dimmer active={activate} />
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          mensaje.titulo === "Exito."
            ? blanquear()
            : setMensaje({
              mostrar: false,
              titulo: "",
              texto: "",
              icono: "",
            });
        }}
      />
      <CatalogoUbicacionBien show={mostrarCatalogo}
        setShow={setMostrarCatalogo}
        onHideCancelar={() => setMostrarCatalogo(false)}
        seleccionarDependencia={seleccionarDependencia}
      />
    </Modal>
  );
}